import Typography from '@/features/ui/typography'
import { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'

const Title: FC = () => {
    const { t } = useTranslation()

    return (
        <Typography.Heading variant="h3">
            {t('common.insertNoteFormContent.insertNote')}
        </Typography.Heading>
    )
}

export default memo(Title)
